import { useCallback, useMemo } from 'react';
import { PROVIDER_CODE } from '@/layout/login/constants';

interface UseOrganizationIdReturn {
  /** Organization ID from session storage */
  organizationId: string | null;
  /** Function to get the organization ID from session storage */
  getOrganizationId: () => string | null;
}

const useOrganizationId = (): UseOrganizationIdReturn => {
  const getOrganizationId = useCallback(
    (): string | null => sessionStorage.getItem(PROVIDER_CODE),
    []
  );

  const organizationId = useMemo(
    () => getOrganizationId(),
    [getOrganizationId]
  );

  return {
    organizationId,
    getOrganizationId,
  };
};

export default useOrganizationId;
